import * as swcHelpers from '@swc/helpers';
import { mergeLabels } from '@grandvisionhq/state';
import { resilientFetch } from '@grandvisionhq/utils';
import '@bloomreach/spa-sdk';
import { createBloomreachResourceUrl } from '../utils/create-resource-url.js';
import { flattenResources } from '../utils/flatten-resources.js';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import { userAgentHeader } from '../utils/http-client.js';

const fetch = resilientFetch();
function getLabels(apiUrl, channel, resourceIds, locale) {
    return _getLabels.apply(this, arguments);
}
function _getLabels() {
    _getLabels = swcHelpers.asyncToGenerator(function*(apiUrl, channel, resourceIds, locale) {
        const url = createBloomreachResourceUrl(apiUrl, channel, resourceIds, locale.replace('-', '_'));
        try {
            const response = yield fetch(url, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'User-Agent': userAgentHeader
                }
            });
            if (!response.ok) {
                throw new Error(`received ${response.status} from Bloomreach`);
            }
            const resources = yield response.json();
            const labelSets = flattenResources(resources);
            return mergeLabels(labelSets);
        } catch (err) {
            console.error(`Error while fetching labels for ${url}`, err);
        }
    });
    return _getLabels.apply(this, arguments);
}

export { getLabels };
//# sourceMappingURL=get-labels.js.map
